import { render, staticRenderFns } from "./Maintainance.vue?vue&type=template&id=12acb3a6&"
import script from "./Maintainance.vue?vue&type=script&lang=js&"
export * from "./Maintainance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports